import base from "/opt/build/repo/images/play.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");